/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BearerInputs */

const cs_enum_bearer = /** @type {(inputs: Enum_BearerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearer`)
};

const en_enum_bearer = /** @type {(inputs: Enum_BearerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearer`)
};

/**
* | output |
* | --- |
* | "Bearer" |
*
* @param {Enum_BearerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_bearer = /** @type {((inputs?: Enum_BearerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BearerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_bearer(inputs)
	return cs_enum_bearer(inputs)
});